(function () {
  'use strict';
  angular.module('claims')
    .component('claimPayments', {
        bindings: {
          promise: '<'
        },
        controller: [ function claimPaymentComponent() {
          var ctrl = this;

          this.$onInit = function () {
            getClaimPayments();
          };

          function getClaimPayments() {
        	ctrl.running = true;
            if (ctrl.promise) {
              ctrl.promise.then(function(response) {
              ctrl.serviceUnavailable = response.serviceUnavailable;
              if(response.data){
            	ctrl.claimPaymentsSearchResults = response.data.payments;
              }
              else {
            	ctrl.claimPaymentsSearchResults = [];
              }
                ctrl.running = false;
              },function(rejection) {
            	ctrl.running = false;
              });
            }
          }
       }],
       templateUrl: '/js/claims/claimPayments.html' + appVersion
      }
    );
})();

